"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserV2Service = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class UserV2Service {
    /**
     * @returns GetUserResponse Ok
     * @throws ApiError
     */
    static getUser() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/user',
        });
    }
    /**
     * @param requestBody
     * @returns UpdateMeResponse Ok
     * @throws ApiError
     */
    static updateMe(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/v2/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns GetUserProfileResponse Ok
     * @throws ApiError
     */
    static getUserProfile() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/user/profile',
        });
    }
    /**
     * @param requestBody
     * @returns UpdateMyContactInfoResponse Ok
     * @throws ApiError
     */
    static updateMyContactInfo(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/v2/user/contact-info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UpsertAddressResponse Ok
     * @throws ApiError
     */
    static upsertAddress(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/v2/user/address',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UpdateEmailPreferencesResponse Ok
     * @throws ApiError
     */
    static updateEmailPreferences(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/v2/user/email-preferences',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Gets the core entitlements for the authenticated user.
     * @returns GetEntitlementsResponse User entitlements retrieved successfully
     * @throws ApiError
     */
    static getEntitlements() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/user/entitlements',
        });
    }
    /**
     * Get user subscriptions
     * Gets all subscriptions for the authenticated user with optional payment method details
     * @param includePaymentMethod
     * @returns GetSubscriptionsResponse User subscriptions retrieved successfully
     * @throws ApiError
     */
    static getSubscriptions(includePaymentMethod) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/user/subscriptions',
            query: {
                'includePaymentMethod': includePaymentMethod,
            },
        });
    }
    /**
     * Processes a subscription purchase for the authenticated user
     * @param requestBody
     * @returns ProcessPurchaseV2Response Subscription processed successfully
     * @throws ApiError
     */
    static processPurchaseV2(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/user/purchase/process',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Gets available TS1 subscription products for the authenticated user.
     * @returns GetUserSubscriptionProductsResponse User subscription products retrieved successfully
     * @throws ApiError
     */
    static getSubscriptionProducts() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/user/subscription/products',
        });
    }
    /**
     * @param requestBody
     * @returns CreateSubscriptionCheckoutSessionV2Response Checkout session created successfully
     * @throws ApiError
     */
    static createCheckoutSessionV2(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/user/subscription/checkout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns CreateSubscriptionPortalSessionV2Response Portal session created successfully
     * @throws ApiError
     */
    static createPortalSessionV2(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/user/subscription/portal',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UpdatePaymentMethodV2Response Payment method updated successfully
     * @throws ApiError
     */
    static updateSubscriptionPaymentMethodV2(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/user/subscription/payment-method/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ResubscribeUserV2Response Resubscribed successfully
     * @throws ApiError
     */
    static resubscribeUserV2() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/user/subscription/resubscribe',
        });
    }
}
exports.UserV2Service = UserV2Service;
